import React, {Component} from "react";
import {cassetteType, progressStage} from "../../utils/const";
import {connect} from "react-redux";
import {updateQueueState} from "../../redux_actions/c240_device_status.action";
import {setDeviceBusy, setDeviceIdle} from "../../redux_actions/device_status.action";
import {initPreviewForScan} from "../../redux_actions/preview_status.action";
import {Spin} from "antd";
import SingleCassetteComponent from "../../component/scanner/scanWorkflow/C240SingleCassetteView";
import { getDeviceProperties } from "redux_actions/device.action";

class C240CassetteView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            removeQueueInteraction: false,
            qPreviewBtnStatusMap: this.initQPreviewBtnStatus(),
            qScanBtnStatusMap: this.initQScanBtnStatus(),
            cassetteSize: 0,
            scannerProperties: {},
        }
    }

    componentDidMount() {
        this.getScannerProperties();
    }

    handleProgressChange = (stage) => {
        this.setState({
            currentProcessStage: progressStage.stage,
        })
        this.props.history.push("/scannerflow/" + this.props.deviceId + "/scan/" + stage + "/");
    }

    getScannerProperties = () => {
        this.props.dispatch(setDeviceBusy(this.props.deviceId, "Setting Up"));

        this.props.dispatch(getDeviceProperties(this.props.deviceId)).then(() => {
            const data = this.props.deviceProperties
            for (let i = 0; i < data.cassetteSize; i++) {
                this.initSlot(i, data.defaultConfig);
            }
            this.setState(Object.assign({}, this.state, {
                defaultConfig: data.defaultConfig,
                scannerProperties: data,
                cassetteSize: data.cassetteSize
            }));
            this.props.dispatch(setDeviceIdle(this.props.deviceId));
        })
    }

    initQPreviewBtnStatus = () => {
        let qPreviewBtnStatus = {};
        for (let rack = 0; rack < 2; rack++) {
            for (let tray = 0; tray < 20; tray++) {
                const cassette_key = `R${rack}T${tray}`;
                qPreviewBtnStatus[cassette_key] = Array(6).fill(false);
            }
        }
        return qPreviewBtnStatus;
    }

    initQScanBtnStatus = () => {
        let qScanBtnStatus = {};
        for (let rack = 0; rack < 2; rack++) {
            for (let tray = 0; tray < 20; tray++) {
                const cassette_key = `R${rack}T${tray}`;
                qScanBtnStatus[cassette_key] = Array(6).fill(false);
            }
        }
        return qScanBtnStatus;
    }

    updatePreviewButtonStatus = (cassette_key, slide_idx, status) => {
        let qPreviewBtnStatusMap = this.state.qPreviewBtnStatusMap;  // reference copy
        qPreviewBtnStatusMap[cassette_key][slide_idx] = status;
        this.setState({
            qPreviewBtnStatusMap: qPreviewBtnStatusMap
        });
    }

    updateScanButtonStatus = (cassette_key, slide_idx, status) => {
        let qScanBtnStatusMap = this.state.qScanBtnStatusMap;
        qScanBtnStatusMap[cassette_key][slide_idx] = status;
        this.setState({
            qPreviewBtnStatusMap: qScanBtnStatusMap
        });
    }

    updateQueueInteraction = (val) => {
        this.setState({
            removeQueueInteraction: val,
        })
    }

    updateQueue = (queueData) => {
        this.props.dispatch(updateQueueState(queueData));
    }

    initSlot = (slot, defaultConfig) => {
        this.props.dispatch(initPreviewForScan(slot, defaultConfig));
    }

    render() {
        let selectedCassette = this.props.selectedCassette;
        let c240DeviceStatus = this.props.c240DeviceStatus;
        let scannerState = c240DeviceStatus.scanner_state;
        let singleCassetteView = [];
        if ((c240DeviceStatus.data || {}).rack_module) {
            let racks = (this.props.c240DeviceStatus.data || {}).rack_module.RACK;
            if (selectedCassette !== null) {
                const trayKey = selectedCassette;
                let cassetteState = {};
                for (let slide_id = 0; slide_id < 6; slide_id++) {
                    const slideKey = `${trayKey}S${slide_id}`;
                    cassetteState[slideKey] = scannerState[slideKey];
                }
                let i = parseInt(trayKey.split("T")[0].split("R")[1]);
                let j = parseInt(trayKey.split("T")[1]);
                let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);
                // myCassetteType = cassetteType.TWO_2_BY_3_SLIDES;
                singleCassetteView.push(
                    <SingleCassetteComponent
                        handleProgressChange={this.handleProgressChange}
                        deviceId={this.props.deviceId}
                        currentProcessIndex={1}
                        highlightSlideKey={this.props.highlightSlideKey}
                        highlight={this.props.highlight}
                        selectedCassette={this.props.selectedCassette}
                        previews={this.props.previews}
                        scannerProperties={this.state.scannerProperties}
                        defaultConfig={this.state.defaultConfig}
                        barcodeTaken={racks[i][j].barcode_taken}
                        isCassetteEmpty={racks[i][j].cassette_state._name_ === "EMPTY"}
                        cassetteState={cassetteState}
                        CassetteType={myCassetteType}
                        queueState={c240DeviceStatus.queue_state}
                        removeQueueInteraction={this.state.removeQueueInteraction}
                        barcodeCacheBustingKey={this.props.barcodeCacheBustingKey}
                        cassetteQPreviewBtnDisable={this.state.qPreviewBtnStatusMap[selectedCassette]}
                        cassetteQScanBtnDisable={this.state.qScanBtnStatusMap[selectedCassette]}
                        onPreviewOnlyClick={(cassetteKey, slideId) => this.updatePreviewButtonStatus(cassetteKey, slideId, true)}
                        enablePreviewBtn={(cassetteKey, slideId) => this.updatePreviewButtonStatus(cassetteKey, slideId, false)}
                        onQScanClick={(cassetteKey, slideId) => this.updateScanButtonStatus(cassetteKey, slideId, true)}
                        enableQScanBtn={(cassetteKey, slideId) => this.updateScanButtonStatus(cassetteKey, slideId, false)}
                        updateQueue={this.updateQueue}
                        updateQueueInteraction={this.updateQueueInteraction}
                        onFinalizeSlideSettingsClick={this.props.onFinalizeSlideSettingsClick}
                        blockUI={this.props.blockUI}
                        onFinalizedSlideSettings={this.props.onFinalizedSlideSettings}/>
                );
            }
        }
        if(singleCassetteView.length === 0){
            return <p>Please select a cassette to see Slides.</p>
        } else if (this.state.cassetteSize === 0) {
            return (<div className="rounded-container full-parent">
                <Spin spinning={this.state.cassetteSize === 0} tip="Loading...">
                    <div className={"full-parent"}></div>
                </Spin>
            </div>);
        } else {
            return singleCassetteView;
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        adminState: state.adminUrlReducer,
        c240LoaderState: state.c240LoaderReducer,
        deviceStatus: state.deviceStatusReducer[ownProps.deviceId],
        drawerCollapsed: state.dashboardReducer.drawerCollapsed,
        deviceProperties: state.deviceAlert.deviceProperties,
        c240DeviceStatus: state.c240DeviceStatusReducer
    };
};

export default connect(mapStateToProps)(C240CassetteView)